export default "__VITE_ASSET__BDxWvNxt__"